import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";

import parse from "html-react-parser";
import { Button, Modal } from "react-bootstrap";
import ExportExcel from "../components/Common/ExportExcel/ExportExcel";
import HEPopup from "../components/popUp/HEPopup";
import "./ESPopupForList.scss";


interface ESPopUpForListProps {
  data: any;
  onUpdateParentValue: (newValue: boolean) => void;
  onCancel?: () => void;
  onConfirm?: () => void;
  message?: string;
  header?: string;
  model?: any;
  componentName?: string;
  fileName?: string;
}

const ESPopUpForList: React.FC<ESPopUpForListProps> = ({
  data,
  onUpdateParentValue,
  onCancel,
  onConfirm,
  message,
  header,
  model,
  componentName,
  fileName,
}) => {
  let cnt = 1;

  const renderTableHeader = () => {
    if (data?.length > 0) {
      const maxLengthRow = data?.reduce(
        (prev: Record<string, any>, current: Record<string, any>) =>
          Object.keys(current)?.length > Object.keys(prev)?.length
            ? current
            : prev
      );
      let headers = Object.keys(maxLengthRow);
      if (componentName === "QuestionsList" || componentName === "UserList") {
        headers = headers?.filter((header) => header !== "IsSuccess");
      }
      return headers?.map((header) => (
        <th className="text-capitalize" key={header}>
          <span className="txt">{header}</span>
        </th>
      ));
    }
  };

  const renderTableData = () => {
    if (data?.length > 0) {
      return data?.map((item: any) => (
        <tr key={item.id}>
          <td>{cnt++}</td>
          {Object.entries(item)?.map(([key, value], index) => {
            if (
              (componentName === "QuestionsList" ||
                componentName === "UserList") &&
              key === "IsSuccess"
            )
              return null;
            const age = item.Message;
            let cellClass = "";
            let cellContent;
            cellContent = value?.toString();

            if (
              (componentName === "QuestionsList" ||
                componentName === "UserList") &&
              key === "IsSuccess"
            ) {
              cellClass =
                value?.toString() === "true"
                  ? "text-success font-weight-bold"
                  : "text-danger font-weight-bold";
            } else if (
              (componentName === "QuestionsList" ||
                componentName === "UserList") &&
              key === "Message"
            ) {
              cellClass =
                item.IsSuccess?.toString() === "true"
                  ? "text-success"
                  : "text-danger";
            }
            return (
              <td key={index} className={cellClass}>
                {cellContent}
              </td>
            );
          })}
        </tr>
      ));
    }
  };

  return (
    <HEPopup
      className="modal modal-lg"
      show={true}
      onHide={() => {
        onUpdateParentValue(false);
      }}
    >
      {header && (
        <Modal.Header
          closeButton
          className="border-none"
          style={{ zIndex: 99 }}
        >
          <div className="d-flex flex-row flex-fill align-items-center justify-content-between">
            <div>{header}</div>
            <div>
              {model && model?.length > 0 && (
                <ExportExcel
                  searchText=""
                  model={model}
                  componentName={componentName}
                  fileName={fileName}
                ></ExportExcel>
              )}
            </div>
          </div>
          {/* <Col md={11}>
            
            
          </Col> */}
        </Modal.Header>
      )}

      <Modal.Body>
        {message && (
          <div>
            {parse(message)}
          </div>
        )}
        <div className="bulkList">
          {data?.length > 0 ? (
            <div className="table-responsive-sm overflow-auto exceltableHeight">
              <table className="table table-sm table-bordered">
                <thead>
                  <tr className="table-primary">
                    {data?.length > 0 && <th>I.</th>}
                    {renderTableHeader()}
                  </tr>
                </thead>
                <tbody>{renderTableData()}</tbody>
              </table>
            </div>
          ) : (
            <p>No data available</p>
          )}
        </div>
      </Modal.Body>
      {onCancel && onConfirm && (
        <Modal.Footer>
          <Button className="save-btn" onClick={onConfirm}>
            Ok
          </Button>
          <Button className="back-btn" onClick={onCancel}>
            Cancel
          </Button>
        </Modal.Footer>
      )}
    </HEPopup>
  );
};

export default ESPopUpForList;
